import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {User, UserCreateRequest, UserPatchRequest} from "./models";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(public http: HttpClient) {
  }

  getMe(): Observable<User> {
    return this.http.get<User>(environment.apiUrl + "/users/me")
  }
  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(environment.apiUrl + "/users");
  }

  getUser(id: number): Observable<User> {
    return this.http.get<User>(environment.apiUrl + "/users/" + id);
  }

  createUser(body: UserCreateRequest): Observable<User> {
    const token = localStorage.getItem('access_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.http.post<User>(environment.apiUrl + "/users", body, {headers});
  }

  deleteUser(id: number) {
    const token = localStorage.getItem('access_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.http.delete(environment.apiUrl + "/users/" + id, {headers});
  }

  patchUser(id: number, body: UserPatchRequest): Observable<User> {
    const token = localStorage.getItem('access_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.http.patch<User>(environment.apiUrl + "/users/" + id, body, {headers});
  }
}
